/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailFramingOptions_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_viewer">;
    readonly " $refType": "PdpSharedDetailFramingOptions_viewer";
};
export type PdpSharedDetailFramingOptions_viewer$data = PdpSharedDetailFramingOptions_viewer;
export type PdpSharedDetailFramingOptions_viewer$key = {
    readonly " $data"?: PdpSharedDetailFramingOptions_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailFramingOptions_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailFramingOptions_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '1829a72576e03e7436b48050770e24d0';
export default node;
